import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
  data: null,
}

export const appConstantsSlice = createSlice({
  name: 'constants',
  initialState,
  reducers: {
    setAppConstants: (state, action) => {
      state.data = action.payload
    },
    clearAppConstants: () => initialState,
  },
})

export const { setAppConstants, clearAppConstants } = appConstantsSlice.actions

export default appConstantsSlice.reducer
